import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SkanoModalState {
	isOpen: boolean;
}

const initialState: SkanoModalState = {
	isOpen: false,
};

const skanoModalSlice = createSlice({
	name: "skanoModal",
	initialState,
	reducers: {
		setSkanoModalOpen: (state, action: PayloadAction<boolean>) => {
			state.isOpen = action.payload;
		},
	},
});

export const { setSkanoModalOpen } = skanoModalSlice.actions;
export default skanoModalSlice.reducer;
